import { default as AssociateRegistrationStatusBadge } from "./AssociateRegistrationStatusBadge.vue";
import { default as ComplaintStatusBadge } from "./ComplaintStatusBadge.vue";
import { default as DisbursementStatusBadge } from "./DisbursementStatusBadge.vue";
import { default as DismantleStatusBadge } from "./DismantleStatusBadge.vue";
import { default as InvoiceStatusBadge } from "./InvoiceStatusBadge.vue";
import { default as InvoiceStatusLargeBadge } from "./InvoiceStatusLargeBadge.vue";
import { default as ProductChangeStatusBadge } from "./ProductChangeStatusBadge.vue";
import { default as ProvisionReturnStatusBadge } from "./ProvisionReturnStatusBadge.vue";
import { default as ProvisionStatusBadge } from "./ProvisionStatusBadge.vue";
import { default as RegistrationStatusBadge } from "./RegistrationStatusBadge.vue";
import { default as SettlementStatusBadge } from "./SettlementStatusBadge.vue";

export const Badge = {
    AssociateRegistrationStatus: AssociateRegistrationStatusBadge,
    ComplaintStatus: ComplaintStatusBadge,
    DisbursementStatus: DisbursementStatusBadge,
    DismantleStatus: DismantleStatusBadge,
    InvoiceStatus: InvoiceStatusBadge,
    InvoiceStatusLarge: InvoiceStatusLargeBadge,
    ProductChangeStatus: ProductChangeStatusBadge,
    ProvisionReturnStatus: ProvisionReturnStatusBadge,
    ProvisionStatus: ProvisionStatusBadge,
    RegistrationStatus: RegistrationStatusBadge,
    SettlementStatus: SettlementStatusBadge,
};
